import { useEffect, useState } from "react";
import { Select } from "antd";
import { useNavigate } from 'react-router-dom';
import StockOsv from "./stock-osv";
import StockRest from "./stock-rest";
import StockDocs from "./stock-docs";
import StockFilter from "./stock-filter";
import { isMobile } from "@/extensions/design";

const Stock = ({ page }) => {
  const [mobilePage, setMobilePage] = useState("stock");
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [items, setItems] = useState([]);
  
  // Список страниц для мобильного селектора
  const pages = [
    { title: "Текущие остатки", link: "stock" },
    { title: "ОСВ", link: "stock-osv"},
    { title: "Накладные", link: "stock-docs"}
  ];

  const getPage = () => {
    switch (page){
      case "stock": return <StockRest />
      case "stock-osv": return <StockOsv />
      case "stock-docs": return <StockDocs filter={selectedFilters} onItemsChange={(newItems) => {setItems(newItems)}}/>
      default: return null;
    }
  }

  const getItem = (title, link) => <a 
    className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} 
    href={`${link}`}>{title}</a>

  return !isMobile ? (
    <div className="col-one-main">
      <div className="col-one-title">
        {getItem("Текущие остатки", "stock")}
        {getItem("ОСВ", "stock-osv")}
        {getItem("Накладные", "stock-docs")}
      </div>
      <div className="col-one-col">
        {getPage()}
      </div>
    </div>) : 
    (
      <div className="sport-form-content">
        <div className="col-one-main">
          <div className="col-one-col">
            <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Склад</div>
            <div className='selector-filer-section'>
              <Select value={page} onChange={(v) => { setMobilePage(v); navigate(`/${v}`); }} style={{width: "100%"}}>
                {pages.map(p => (
                  <Select.Option key={p.link} value={p.link}>
                    {p.title}
                  </Select.Option>
                ))}
              </Select>
              { page == "stock-docs" ? 
                (<img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>) :
              (<></>)}
              {showFilter && <StockFilter items={items} value={selectedFilters} onClose={(filters) => { setShowFilter(false); if (filters) setSelectedFilters(filters);}}/>}
            </div>
            {getPage()}
          </div>
        </div>
      </div>
    )
}

export default Stock;